import { useTranslation } from 'react-i18next';
import Price from '@/components/ui/Price';

interface Props {
  count: number;
  subtotalCents: number;
  onOpen: () => void;
}

/**
 * Barre basse du carnet du serveur : ce qu'il vient de saisir, et par ou le
 * valider, a portee de pouce.
 *
 * Le total du haut est celui de la TABLE (tournees deja envoyees, lu du
 * serveur) ; celui-ci est le total de la tournee EN COURS, la seule chose que
 * le serveur relit avant d'envoyer en cuisine. Sans elle, la commande en cours
 * n'existait que derriere une petite icone en haut a droite — le pire coin a
 * atteindre sur un telephone de 844 px tenu d'une main.
 *
 * Ne s'affiche que lorsqu'il y a quelque chose a valider : un panier vide ne
 * merite pas 52 px pris sur la carte.
 */
export default function WaiterCartBar({ count, subtotalCents, onOpen }: Props) {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[500] border-t-2 border-ink bg-ink px-3 pt-2"
      style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}
    >
      <button
        type="button"
        onClick={onOpen}
        data-testid="waiter-cart-bar"
        className="flex w-full items-center gap-3 border-0 bg-transparent p-0 text-paper"
      >
        {/* « n au panier » plutot qu'un pluriel : i18next irait chercher des
            cles suffixees (_one/_other, et six formes en arabe) qu'aucune des
            cinq locales ne definit. */}
        <span className="font-mono text-sm">{t('waiter.cartBar.items', { n: count })}</span>
        <span className="ms-auto font-mono text-base font-bold">
          <Price amountCents={subtotalCents} className="text-base" />
        </span>
        <span className="rounded-btn-sm border-2 border-ink bg-mint px-3 py-1.5 font-display text-sm text-[var(--on-primary)]">
          {t('waiter.cartBar.review')}
        </span>
      </button>
    </div>
  );
}
